var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17.1H3C2.449 17.1 2 16.6734 2 16.15V10.45H16V16.15C16 16.6734 15.551 17.1 15 17.1ZM3 3.80005H4V4.75005C4 5.27255 4.45 5.70005 5 5.70005C5.55 5.70005 6 5.27255 6 4.75005V3.80005H12V4.75005C12 5.27255 12.45 5.70005 13 5.70005C13.55 5.70005 14 5.27255 14 4.75005V3.80005H15C15.551 3.80005 16 4.2266 16 4.75005V8.55005H2V4.75005C2 4.2266 2.449 3.80005 3 3.80005ZM15 1.9H14V0.95C14 0.4275 13.55 0 13 0C12.45 0 12 0.4275 12 0.95V1.9H6V0.95C6 0.4275 5.55 0 5 0C4.45 0 4 0.4275 4 0.95V1.9H3C1.346 1.9 0 3.1787 0 4.75V16.15C0 17.7213 1.346 19 3 19H15C16.654 19 18 17.7213 18 16.15V4.75C18 3.1787 16.654 1.9 15 1.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5208562d5dac4ba0286ec8330c95efd0.svg";
export { ForwardRef as ReactComponent };